import { Component, OnInit, inject } from '@angular/core';
import { ProfileService } from 'src/app/services/profile.service';
import { AdminService } from 'src/app/services/admin.service';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { App } from '@capacitor/app';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { AudioService } from 'src/app/services/audio.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ConsentService } from 'src/app/services/consent.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {
  profileService = inject(ProfileService);
  adminService = inject(AdminService);
  authService = inject(AuthService);
  audioService = inject(AudioService);
  consentService = inject(ConsentService);
  private analyticsService = inject(AnalyticsService);
  guestAcc: boolean = false;
  appVersion = "";

  /** Der Abschnitt erscheint nur, wenn die Abfrage ueberhaupt aktiv ist. */
  consentRequired = environment.consentRequired;

  get marketingConsentGranted(): boolean {
    return this.consentService.hasMarketingConsent();
  }

  /**
   * Widerruf raeumt auch das auf, was nur mit Einwilligung gespeichert werden
   * durfte - ein Widerruf, der die Daten liegen laesst, waere keiner.
   */
  onMarketingConsentToggle(event: any): void {
    if (event?.detail?.checked) {
      this.consentService.grantMarketing();
      this.analyticsService.persistFirstTouchAfterConsent();
      ToastService.makeToast('Danke — das hilft uns sehr.');
    } else {
      this.consentService.revoke();
      this.consentService.denyMarketing();
      ToastService.makeToast('Gespeicherte Herkunft wurde gelöscht.');
    }
  }

  constructor(
    private alertController: AlertController,
    private navCtr: NavController,
    private loadingCtrl: LoadingController) { }

  async ngOnInit() {
    this.guestAcc = this.profileService.userProfile?.isGuest() || false;

    const appInfo = await App.getInfo();
    this.appVersion = appInfo.version;
  }

  async saveProfileData() {
    const loading = await this.loadingCtrl.create({
      message: 'Speichere Einstellungen...',
    });
    await loading.present();

    await this.profileService.saveProfile();
    loading.dismiss();
  }

  async deleteAccount() {
    const alert = await this.alertController.create({
      header: "Account löschen",
      message: "Willst Du Deinen Account wirklich löschen? Alle deine Spielstände und Errungenschaften werden dauerhaft gelöscht.",
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            ToastService.makeToast(
              "Eine sehr gute Entscheidung :)"
            );
          }
        },
        {
          text: 'Löschen',
          handler: async () => {
            const checkAlert = await this.alertController.create({
              cssClass: "keyboard-alert",
              header: "Account löschen",
              message: "Tippe Bye-Melowish ein um das Löschen zu bestätigen. Dieser Vorgang kann nicht rückgängig gemacht werden.",
              inputs: [
                {
                  name: 'checkString',
                  placeholder: 'Bye-Melowish',

                },
              ],
              buttons: [
                {
                  text: "Abbrechen",
                  role: "cancel",
                  handler: (data: any) => {
                    ToastService.makeToast(
                      "Eine sehr gute Entscheidung :)"
                    );
                  },
                },
                {
                  text: "Löschen",
                  handler: async (data: any) => {
                    if(data.checkString == "Bye-Melowish") {
                      this.authService.deleteUser().then(() => {
                        this.navCtr.navigateRoot(["home"]);
                        ToastService.makeToast("Dein Account wurde erfolgreich gelöscht.");
                      })
                      .catch(async (error) => {
                        console.error("Error deleting user: ", error);
                        const errorAlert = await this.alertController.create({
                          header: "Account löschen",
                          message: "Aus Sicherheitsgründen musst Du Dich für die Löschung Deines Accounts aus- und dann einloggen. Bitte versuche es danach nochmal - sollte der Fehler weiterhin bestehen, dann kontaktiere den Support.",
                          buttons: [
                            {
                              text: 'Okay',
                              role: 'cancel',
                              handler: () => {
                                this.navCtr.navigateRoot(["home"]);
                              }
                            }
                          ]
                        });
                        await errorAlert.present();
                      });
                      return true;
                    } else {
                      ToastService.makeLowToast("Die Sicherheitseingabe stimmt nicht überein.")
                      return false;
                    }
                  },
                },
              ],
            });

            await checkAlert.present();


          }
        },
      ]
    });
    await alert.present();
  }

}
